
@switch (client.sizeId > 1) {
  @case (true) {
    <div [grid]="2"
      [gridColumnGap]="'20px'"
      [gridRowGap]="'20px'"
      >
      <!-- account details -->
      <section2 icon="account"
        [gridColumn]="1"
        link="/account/edit"
        title="About you">
        <h6 class="p1 m-b-3">{{customerName}}</h6>
        @if (email) {
          <p
            class="p1 m-b-3 col-11 truncate"
          style="text-overflow: ellipsis;max-width: 100%;"> {{email}}</p>
        }
        <div class="flex flex-middle">
          <i class="icon-lock m-r-2"
          style="font-size: 1.2rem;"></i>
          <span class="p1 col-11">••••••••••</span>
        </div>
      </section2>
      <!-- default address -->
      <section2 icon="home"
        [gridColumn]="1"
        [link]="firstAddress ? '/account/address-book' : undefined"
        linkCopy="View all"
        title="Address book">
        @switch (!!firstAddress) {
          <!-- address -->
          @case (true) {
            <h6 class="p1 m-b">{{firstAddress.data.firstname}} {{firstAddress.data.lastname}} @if (firstAddress.data.nickname) {
              ({{firstAddress.data.nickname}})
            }
          </h6>
          <div class="col-11 p1">
            <p>{{firstAddress.data.street_1}}</p>
            @if (firstAddress.data.street_2) {
              <p>{{firstAddress.data.street_2}}</p>
            }
            <p>{{firstAddress.data.city}}</p>
            <p>{{firstAddress.data.postcode}}</p>
            <p class="m-t-6">{{firstAddress.data.telephone}}</p>
          </div>
        }
        <!-- no addresses -->
        @case (false) {
          <p class="col-11 p1 m-b-6"
          translate>You don’t have any saved address</p>
          <a class="button"
            routerLink="/account/address-book"> <span class="button__body"
          translate>Add new address</span></a>
        }
      }
    </section2>
    <!-- payment methods -->
    @if (defaultCard) {
      <section2
        link="/account/payment-methods"
        linkCopy="View all"
        icon="payment"
        [gridColumn]="1"
        title="Payment methods">
        <div class="flex">
          <div class="m-r-5 payment-method-logo"
            [ngClass]="'payment-method-logo--' + (defaultCard.data.type | lowercase)">
          </div>
          <div class="p1 col-11">
            <p>**** **** **** {{defaultCard.data.last_four}}</p>
            <p [ngClass]="{'col-2': isCardExpired(defaultCard.data.expiry_date)}"> Exp.
            {{ defaultCard.data.expiry_date }}</p>
          </div>
        </div>
      </section2>
    }
  </div>
}
@case (false) {
  <account-greeting class="block center"></account-greeting>
  <account-navigation class="block m-t-10"></account-navigation>
}
}
